import CasinoNavigation, { CasinoNavigate } from './components/organisms/CasinoNavigation';
import { Circle } from '@mui/icons-material';
import { Navigate, createBrowserRouter } from 'react-router';
import Root from './components/Root';
import ProtectedNavigate from './components/atoms/ProtectedNavigate';
import ProtectedPage from './components/layouts/ProtectedPage';
import UserManagementPageLayout from './components/layouts/UserManagementPageLayout';
import TabNavigation from './components/organisms/TabNavigation';
import CashbackBonusPage from './components/pages/CashbackBonusPage';
import SelectionsBonusPage from './components/pages/SelectionsBonusPage';
import WelcomeBonusPage from './components/pages/WelcomeBonusPage';
import CMSStudioPage from './components/pages/CMSStudioPage';
import CashoutPage from './components/pages/CashoutPage';
import CasinoGamesPage from './components/pages/CasinoGamesPage';
import CasinoCategoriesPage from './components/pages/CasinoCategoriesPage';
import CasinoProvidersPage from './components/pages/CasinoProvidersPage';
import CasinoUsersPage from './components/pages/CasinoUsersPage';
import CasinoTransactionsPage from './components/pages/CasinoTransactionsPage';
import CasinoFreeSpinsPage from './components/pages/CasinoFreeSpinsPage';
import CasinoBetsPage from './components/pages/CasinoBetsPage';
import CasinoReportsPage from './components/pages/CasinoReportsPage';
import CasinoMarketplacePage from './components/pages/CasinoMarketplacePage';
import CompetitionsPage from './components/pages/CompetitionsPage';
import DailyReportsPage from './components/pages/DailyReportsPage';
import DeletedMessagesPage from './components/pages/DeletedMessagesPage';
import ErrorPage from './components/pages/ErrorPage';
import EventsPage from './components/pages/EventsPage';
import EventsResultsPage from './components/pages/EventsResultsPage';
import JackpotPage from './components/pages/JackpotPage';
import LiabilityMonitoringPage from './components/pages/LiabilityMonitoringPage';
import MarketGroupsPage from './components/pages/MarketGroupsPage';
import MarketTypesPage from './components/pages/MarketTypesPage';
import MessagesInboxPage from './components/pages/MessagesInboxPage';
import MessagesSentPage from './components/pages/MessagesSentPage';
import OutcomeTypesPage from './components/pages/OutcomeTypesPage';
import OutrightsPage from './components/pages/OutrightsPage';
import ParticipantsPage from './components/pages/ParticipantsPage';
import PlayersPage from './components/pages/PlayersPage';
import PublishEventsPage from './components/pages/PublishEventsPage';
import SportsPage from './components/pages/SportsPage';
import SuperAdminActionsPage from './components/pages/SuperAdminActionsPage';
import SuperAdminCryptoDashboardPage from './components/pages/SuperAdminCryptoDashboardPage';
import SuperAdminAccountsPage from './components/pages/SuperAdminAccountsPage';
import SuperAdminBullboardPage from './components/pages/SuperAdminBullboardPage';
import SuperAdminDashboardIframePage from './components/pages/SuperAdminDashboardIframePage';
import SuperAdminDatabaseQueriesPage from './components/pages/SuperAdminDatabaseQueriesPage';
import SuperAdminFlagsPage from './components/pages/SuperAdminFlagsPage';
import TicketAuthorizationPage from './components/pages/TicketAuthorizationPage';
import TicketMonitoringPage from './components/pages/TicketMonitoringPage';
import TournamentsPage from './components/pages/TournamentsPage';
import ConditionEntityPage from './components/pages/conditions/ConditionEntityPage';
import ConditionGroupsPage from './components/pages/conditions/ConditionGroupsPage';
import ConditionTypesPage from './components/pages/conditions/ConditionTypesPage';
import TicketsConditionsPage from './components/pages/conditions/TicketsConditionsPage';
import CustomersPage from './components/pages/crm/CustomersPage';
import PartnersPage from './components/pages/crm/PartnersPage';
import CustomerWalletLayoutPage from './components/pages/crm/wallet/CustomerWalletLayoutPage';
import CustomerWalletTransactionPage from './components/pages/crm/wallet/CustomerWalletTransactionPage';
import MyWalletLayoutPage from './components/pages/crm/wallet/MyWalletLayoutPage';
import MyWalletTransactionPage from './components/pages/crm/wallet/MyWalletTransactionPage';
import PaymentTransactionPage from './components/pages/crm/wallet/PaymentTransactionPage';
import TotalCreditPage from './components/pages/crm/wallet/TotalCreditPage';
import AgentsReportPage from './components/pages/reports/AgentsReportsPage';
import AffiliatesReportPage from './components/pages/reports/AffiliatesReportsPage';
import CashoutReportsPage from './components/pages/reports/CashoutReportsPage';
import JackpotReportsPage from './components/pages/reports/JackpotReportsPage';
import ManagersReportPage from './components/pages/reports/ManagersReportsPage';
import PlayersReportPage from './components/pages/reports/PlayersReportsPage';
import PaymentsListReportsPage from './components/pages/reports/payments/PaymentsListReportsPage';
import PaymentsTotalReportsPage from './components/pages/reports/payments/PaymentsTotalReportsPage';
import SportsbookReportsEntityPage from './components/pages/reports/sportsbook/SportsbookReportsEntityPage';
import RiskManagementEntityPage from './components/pages/risk-management/RiskManagementEntityPage';
import RiskSettingsPage from './components/pages/risk-management/RiskSettingsPage';
import BonusReportsPage from './components/pages/reports/BonusReportsPage';
import DepositSettingsPage from './components/pages/DepositSettingsPage';
import WithdrawalSettingsPage from './components/pages/WithdrawalSettingsPage';
import ApprovalsPage from './components/pages/ApprovalsPage';
import CampaignsPage from './components/pages/CampaignsPage';
import {
  BETTING_OFFER_TABS,
  BONUS_TABS,
  CONDITIONS_TABS,
  CRM_PAGE_TABS,
  AFFILIATE_TABS,
  MARKET_CATEGORIES_TABS,
  MESSAGES_TABS,
  OFFER_MANAGEMENT_TABS,
  PARTNERS_REPORT_TABS,
  PAYMENTS_TABS,
  PAYMENT_SETTINGS_TABS,
  PRODUCT_REPORTS_TABS,
  RISK_MANAGEMENT_TABS,
  SUPER_ADMIN_DASHBOARD_TABS,
  SUPER_ADMIN_TABS,
  SPORTSBOOK_TABS,
  SPORTS_BETTING_TABS,
  USER_MANAGEMENT_TABS,
} from './constants';
import { runtimeEnv } from './config/runtimeEnv';
import { SelectedCRMUserProvider } from './contexts/CRMUserContext';
import MarketplacePage from './components/pages/MarketplacePage';
import MarketMixPage from './components/pages/MarketMixPage';
import { FEATURE_FLAG } from './constants/featureFlags';
import AffiliateCampaignReportsPage from './components/pages/reports/AffiliateCampaignReportsPage';
import { JACKPOT_TABS } from './constants/jackpot';

export const routes = [
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorPage text='Page not found' />,
    children: [
      {
        path: 'sports-betting',
        element: <ProtectedPage permission='accessSportsBetting' requireTenant requireSportsbook />,
        children: [
          {
            index: true,
            element: <ProtectedNavigate tabs={SPORTS_BETTING_TABS} />,
          },
          {
            path: 'settings',
            element: (
              <TabNavigation
                basePath='sports-betting/settings'
                tabs={BETTING_OFFER_TABS}
                icon={<Circle fontSize='inherit' />}
              />
            ),
            children: [
              {
                index: true,
                element: <ProtectedNavigate tabs={BETTING_OFFER_TABS} />,
              },
              {
                element: <ProtectedPage permission='manageBettingSettings' />,
                children: [
                  {
                    path: 'sports',
                    element: <SportsPage />,
                  },
                ],
              },
              {
                element: <ProtectedPage permission='manageBettingSettings' />,
                children: [
                  {
                    path: 'competitions',
                    element: <CompetitionsPage />,
                  },
                ],
              },
              {
                element: <ProtectedPage permission='manageBettingSettings' />,
                children: [
                  {
                    path: 'tournaments',
                    element: <TournamentsPage />,
                  },
                ],
              },
              {
                element: <ProtectedPage permission='manageBettingSettings' />,
                children: [
                  {
                    path: 'participants',
                    element: <ParticipantsPage />,
                  },
                ],
              },
              {
                element: <ProtectedPage permission='manageBettingSettings' />,
                children: [
                  {
                    path: 'players',
                    element: <PlayersPage />,
                  },
                ],
              },
              {
                element: <ProtectedPage permission='manageBettingSettings' />,
                children: [
                  {
                    path: 'markets',
                    element: <MarketTypesPage />,
                  },
                ],
              },
              {
                element: <ProtectedPage permission='manageBettingSettings' />,
                children: [
                  {
                    path: 'outcomes',
                    element: <OutcomeTypesPage />,
                  },
                ],
              },
              {
                element: <ProtectedPage permission='accessPublishEvents' />,
                children: [
                  {
                    path: 'publish-events',
                    element: <PublishEventsPage />,
                  },
                ],
              },
              {
                element: <ProtectedPage permission='manageBettingSettings' />,
                children: [
                  {
                    path: 'market-categories',
                    element: <TabNavigation tabs={MARKET_CATEGORIES_TABS} />,
                    children: [
                      {
                        index: true,
                        element: <Navigate to='./market-groups' />,
                      },
                      {
                        path: 'market-groups',
                        element: <MarketGroupsPage />,
                      },
                      {
                        element: (
                          <ProtectedPage
                            permission='manageBettingSettings'
                            featureFlag={FEATURE_FLAG.TOURNAMENT_MARKET_GROUPS}
                          />
                        ),
                        children: [
                          {
                            path: 'market-mix',
                            element: <MarketMixPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                element: <ProtectedPage permission='accessConditions' />,
                children: [
                  {
                    path: 'conditions',
                    element: <TabNavigation tabs={CONDITIONS_TABS} />,
                    children: [
                      {
                        index: true,
                        element: <Navigate to='./conditions-type' />,
                      },
                      { path: 'conditions-type', element: <ConditionTypesPage /> },
                      { path: 'conditions-groups', element: <ConditionGroupsPage /> },
                      { path: 'sports', element: <ConditionEntityPage /> },
                      { path: 'competitions', element: <ConditionEntityPage /> },
                      { path: 'tournaments', element: <ConditionEntityPage /> },
                      { path: 'markets', element: <ConditionEntityPage /> },
                      { path: 'agents', element: <ConditionEntityPage /> },
                      { path: 'punters', element: <ConditionEntityPage /> },
                      { path: 'tickets', element: <TicketsConditionsPage /> },
                    ],
                  },
                ],
              },
              {
                element: <ProtectedPage permission='accessRiskManagement' />,
                children: [
                  {
                    path: 'risk-management',
                    element: <TabNavigation tabs={RISK_MANAGEMENT_TABS} />,
                    children: [
                      {
                        index: true,
                        element: <Navigate to='./risk-settings' />,
                      },
                      {
                        path: 'risk-settings',
                        element: <RiskSettingsPage />,
                      },
                      { path: 'sports', element: <RiskManagementEntityPage /> },
                      { path: 'tournaments', element: <RiskManagementEntityPage /> },
                      { path: 'markets', element: <RiskManagementEntityPage /> },
                      { path: 'players', element: <RiskManagementEntityPage /> },
                    ],
                  },
                ],
              },
            ],
          },
          {
            element: <ProtectedPage permission='manageOffer' requireSportsbook />,
            children: [
              {
                path: 'offer-management',
                element: <TabNavigation tabs={OFFER_MANAGEMENT_TABS} icon={<Circle fontSize='inherit' />} />,
                children: [
                  {
                    index: true,
                    element: <ProtectedNavigate tabs={OFFER_MANAGEMENT_TABS} />,
                  },
                  {
                    element: <ProtectedPage permission='manageEvents' />,
                    children: [
                      {
                        path: 'events',
                        element: <EventsPage />,
                      },
                    ],
                  },
                  {
                    element: <ProtectedPage permission='manageEvents' />,
                    children: [
                      {
                        path: 'outrights',
                        element: <OutrightsPage />,
                      },
                    ],
                  },
                  {
                    element: <ProtectedPage permission='manageEventsResults' />,
                    children: [
                      {
                        path: 'results',
                        element: <EventsResultsPage />,
                      },
                    ],
                  },
                  {
                    element: <ProtectedPage permission='accessTicketMonitoring' />,
                    children: [
                      {
                        path: 'ticket-monitoring',
                        element: <TicketMonitoringPage />,
                      },
                    ],
                  },
                  {
                    element: <ProtectedPage permission='accessTicketAuthorization' />,
                    children: [
                      {
                        path: 'ticket-authorization',
                        element: <TicketAuthorizationPage />,
                      },
                    ],
                  },
                  {
                    element: <ProtectedPage permission='accessLiabilityMonitoring' />,
                    children: [
                      {
                        path: 'liability-monitoring',
                        element: <LiabilityMonitoringPage />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        element: <ProtectedPage permission='accessCampaigns' marketplaceSystemFlag='affiliate' requireTenant />,
        children: [
          {
            path: 'affiliate',
            element: <TabNavigation tabs={AFFILIATE_TABS} icon={<Circle fontSize='inherit' />} />,
            children: [
              {
                index: true,
                element: <Navigate to='./campaigns' />,
              },
              {
                path: 'campaigns',
                element: <CampaignsPage />,
              },
              {
                path: 'campaign-reports',
                element: <AffiliateCampaignReportsPage />,
              },
            ],
          },
        ],
      },
      {
        path: 'casino',
        element: <CasinoNavigation />,
        children: [
          {
            index: true,
            element: <CasinoNavigate />,
          },
          {
            element: <ProtectedPage permission='viewCasinoReports' requireTenant />,
            children: [{ path: 'reports', element: <CasinoReportsPage /> }],
          },
          {
            element: <ProtectedPage permission='manageCasinoGames' requireTenant />,
            children: [{ path: 'games', element: <CasinoGamesPage /> }],
          },
          {
            element: <ProtectedPage permission='viewCasinoBets' requireTenant />,
            children: [{ path: 'bets', element: <CasinoBetsPage /> }],
          },
          {
            element: <ProtectedPage permission='manageCasinoProviders' requireTenant />,
            children: [{ path: 'providers', element: <CasinoProvidersPage /> }],
          },
          {
            element: <ProtectedPage permission='viewCasinoTransactions' requireTenant />,
            children: [{ path: 'transactions', element: <CasinoTransactionsPage /> }],
          },
          {
            element: <ProtectedPage permission='defaultAdminRole' requireTenant />,
            children: [{ path: 'free-spins', element: <CasinoFreeSpinsPage /> }],
          },
          {
            element: <ProtectedPage permission='viewCasinoUsers' requireTenant />,
            children: [{ path: 'users', element: <CasinoUsersPage /> }],
          },
          {
            element: <ProtectedPage permission='manageCasinoCategories' requireTenant />,
            children: [{ path: 'categories', element: <CasinoCategoriesPage /> }],
          },
          {
            element: <ProtectedPage permission='defaultSuperAdminRole' requireTenant />,
            children: [
              {
                path: 'marketplace',
                element: <CasinoMarketplacePage />,
              },
            ],
          },
          {
            path: '*',
            element: <CasinoNavigate replace />,
          },
        ],
      },
      {
        path: 'messages',
        element: <TabNavigation tabs={MESSAGES_TABS} icon={<Circle fontSize='inherit' />} />,
        children: [
          {
            index: true,
            element: <Navigate to='./inbox' />,
          },
          {
            path: 'inbox',
            element: <MessagesInboxPage />,
          },
          {
            path: 'sent',
            element: <MessagesSentPage />,
          },
          {
            path: 'deleted',
            element: <DeletedMessagesPage />,
          },
        ],
      },
      {
        element: <ProtectedPage permission='manageBonuses' requireTenant />,
        children: [
          {
            path: 'bonus',
            element: <TabNavigation tabs={BONUS_TABS} icon={<Circle fontSize='inherit' />} />,
            children: [
              {
                index: true,
                element: <ProtectedNavigate tabs={BONUS_TABS} />,
              },
              {
                path: 'welcome',
                element: <ProtectedPage permission='manageBonuses' requireSportsbook />,
                children: [
                  {
                    index: true,
                    element: <WelcomeBonusPage />,
                  },
                ],
              },
              {
                path: 'cashback',
                element: <CashbackBonusPage />,
              },
              {
                path: 'selections',
                element: <ProtectedPage permission='manageBonuses' requireSportsbook />,
                children: [
                  {
                    index: true,
                    element: <SelectionsBonusPage />,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        element: <ProtectedPage permission='manageJackpots' requireTenant />,
        children: [
          {
            path: 'jackpot',
            element: <TabNavigation tabs={JACKPOT_TABS} icon={<Circle fontSize='inherit' />} />,
            children: [
              {
                index: true,
                element: <ProtectedNavigate tabs={JACKPOT_TABS} />,
              },
              {
                element: <ProtectedPage permission='manageJackpots' requireSportsbook />,
                children: [
                  {
                    path: 'sportsbook',
                    element: <JackpotPage key='sportsbook' product='sportsbook' />,
                  },
                ],
              },
              {
                element: <ProtectedPage permission='manageJackpots' requireCasino casinoConfigFlag='jackpotEnabled' />,
                children: [
                  {
                    path: 'casino',
                    element: <JackpotPage key='casino' product='casino' />,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        element: <ProtectedPage permission='accessCMS' requireTenant />,
        children: [
          {
            path: 'cms',
            element: <CMSStudioPage />,
            children: [
              {
                path: '*',
                element: <CMSStudioPage />,
              },
            ],
          },
        ],
      },
      {
        element: <ProtectedPage permission='manageCashOut' requireTenant requireSportsbook />,
        children: [
          {
            path: 'cash-out',
            element: <CashoutPage />,
          },
        ],
      },
      {
        element: <ProtectedPage permission='accessCRM' requireTenant />,
        children: [
          {
            path: 'crm',
            element: (
              <SelectedCRMUserProvider>
                <TabNavigation tabs={CRM_PAGE_TABS} icon={<Circle fontSize='inherit' />} />
              </SelectedCRMUserProvider>
            ),
            children: [
              {
                index: true,
                element: <ProtectedNavigate tabs={CRM_PAGE_TABS} />,
              },
              {
                element: <ProtectedPage permission='accessPartners' />,
                children: [
                  {
                    path: 'partners',
                    element: <PartnersPage />,
                  },
                ],
              },
              {
                element: <ProtectedPage permission='accessPlayers' />,
                children: [
                  {
                    path: 'players',
                    element: <CustomersPage />,
                  },
                ],
              },
              {
                path: ':userType/:userId',
                children: [
                  {
                    path: 'wallet',
                    element: <CustomerWalletLayoutPage />,
                    children: [
                      {
                        index: true,
                        element: <Navigate to='./total-credit' />,
                      },
                      {
                        path: 'total-credit',
                        element: <TotalCreditPage />,
                      },
                      {
                        path: 'payment-transaction',
                        element: <PaymentTransactionPage />,
                      },
                      {
                        path: 'wallet-transaction',
                        element: <CustomerWalletTransactionPage />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'my-wallet',
        element: <MyWalletLayoutPage />,
        children: [
          {
            index: true,
            element: <Navigate to='./wallet-transaction' />,
          },
          {
            path: 'wallet-transaction',
            element: <MyWalletTransactionPage />,
          },
        ],
      },
      {
        element: <ProtectedPage permission='accessUserManagement' />,
        children: [
          {
            path: 'user-management',
            element: <TabNavigation tabs={USER_MANAGEMENT_TABS} icon={<Circle fontSize='inherit' />} />,
            children: [
              {
                index: true,
                element: <Navigate to='./users' />,
              },
              {
                path: 'users',
                element: (
                  <UserManagementPageLayout
                    title='Users'
                    src='/admin/sportsbook-bo-users/console/#/sportsbook-bo-users/users'
                  />
                ),
              },
              {
                path: 'groups',
                element: (
                  <UserManagementPageLayout
                    title='Groups'
                    src='/admin/sportsbook-bo-users/console/#/sportsbook-bo-users/groups'
                  />
                ),
              },
            ],
          },
        ],
      },
      {
        element: <ProtectedPage permission='accessProductReports' requireTenant />,
        children: [
          {
            path: 'betting-reports',
            element: (
              <TabNavigation
                basePath='betting-reports'
                tabs={PRODUCT_REPORTS_TABS}
                icon={<Circle fontSize='inherit' />}
              />
            ),
            children: [
              {
                index: true,
                element: <ProtectedNavigate tabs={PRODUCT_REPORTS_TABS} />,
              },
              {
                element: <ProtectedPage permission='viewDailyReports' requireSportsbook />,
                children: [
                  {
                    path: 'daily',
                    element: <DailyReportsPage />,
                  },
                ],
              },
              {
                element: <ProtectedPage permission='viewSportsbookReports' requireSportsbook />,
                children: [
                  {
                    path: 'sportsbook',
                    element: <TabNavigation tabs={SPORTSBOOK_TABS} />,
                    children: [
                      {
                        index: true,
                        element: <Navigate to='./sports' />,
                      },
                      { path: 'sports', element: <SportsbookReportsEntityPage /> },
                      { path: 'tournaments', element: <SportsbookReportsEntityPage /> },
                      { path: 'markets', element: <SportsbookReportsEntityPage /> },
                    ],
                  },
                ],
              },
              {
                element: <ProtectedPage permission='viewPartnersReports' standaloneCasinoSystemFlag='affiliate' />,
                children: [
                  {
                    path: 'partners',
                    element: <TabNavigation tabs={PARTNERS_REPORT_TABS} />,
                    children: [
                      {
                        index: true,
                        element: <ProtectedNavigate tabs={PARTNERS_REPORT_TABS} />,
                      },
                      {
                        element: <ProtectedPage permission='viewManagersReports' requireSportsbook />,
                        children: [{ path: 'managers', element: <ManagersReportPage /> }],
                      },
                      {
                        element: <ProtectedPage permission='viewAgentsReports' requireSportsbook />,
                        children: [{ path: 'agents', element: <AgentsReportPage /> }],
                      },
                      {
                        element: <ProtectedPage permission='viewAffiliatesReports' marketplaceSystemFlag='affiliate' />,
                        children: [{ path: 'affiliates', element: <AffiliatesReportPage /> }],
                      },
                    ],
                  },
                ],
              },
              {
                element: <ProtectedPage permission='viewPlayersReports' requireSportsbook />,
                children: [{ path: 'players', element: <PlayersReportPage /> }],
              },
              {
                element: <ProtectedPage permission='viewPaymentReports' requireSportsbook />,
                children: [
                  {
                    path: 'payments',
                    element: <TabNavigation tabs={PAYMENTS_TABS} />,
                    children: [
                      {
                        index: true,
                        element: <Navigate to='./total' />,
                      },
                      { path: 'total', element: <PaymentsTotalReportsPage /> },
                      { path: 'list', element: <PaymentsListReportsPage /> },
                    ],
                  },
                ],
              },
              {
                element: <ProtectedPage permission='viewBonusReports' requireSportsbook />,
                children: [{ path: 'bonus', element: <BonusReportsPage /> }],
              },
              {
                element: <ProtectedPage permission='accessReportsJackpot' />,
                children: [
                  {
                    path: 'jackpot',
                    element: <TabNavigation tabs={JACKPOT_TABS} />,
                    children: [
                      {
                        index: true,
                        element: <ProtectedNavigate tabs={JACKPOT_TABS} />,
                      },
                      {
                        element: <ProtectedPage permission='accessReportsJackpot' requireSportsbook />,
                        children: [
                          {
                            path: 'sportsbook',
                            element: <JackpotReportsPage key='sportsbook' product='sportsbook' />,
                          },
                        ],
                      },
                      {
                        element: (
                          <ProtectedPage
                            permission='accessReportsJackpot'
                            requireCasino
                            casinoConfigFlag='jackpotEnabled'
                          />
                        ),
                        children: [
                          {
                            path: 'casino',
                            element: <JackpotReportsPage key='casino' product='casino' />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                element: <ProtectedPage permission='viewCashoutReports' requireSportsbook />,
                children: [
                  {
                    path: 'cashout',
                    element: <CashoutReportsPage />,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        element: (
          <ProtectedPage permission='accessPaymentSettings' requireTenant marketplaceFeatureFlag='paymentSettings' />
        ),
        children: [
          {
            path: 'payments',
            element: <TabNavigation tabs={PAYMENT_SETTINGS_TABS} icon={<Circle fontSize='inherit' />} />,
            children: [
              {
                index: true,
                element: <Navigate to='./deposit-settings' />,
              },
              {
                path: 'deposit-settings',
                element: <DepositSettingsPage />,
              },
              {
                path: 'withdrawal-settings',
                element: <WithdrawalSettingsPage />,
              },
              {
                path: 'approvals',
                element: <ApprovalsPage />,
              },
            ],
          },
        ],
      },
      {
        element: <ProtectedPage permission='accessMarketplace' />,
        children: [
          {
            path: 'marketplace',
            element: <MarketplacePage />,
          },
        ],
      },
      {
        element: <ProtectedPage permission='defaultSuperAdminRole' />,
        children: [
          {
            path: 'super-admin',
            element: (
              <TabNavigation basePath='super-admin' tabs={SUPER_ADMIN_TABS} icon={<Circle fontSize='inherit' />} />
            ),
            children: [
              {
                index: true,
                element: <Navigate to='./flags' />,
              },
              {
                element: <ProtectedPage permission='defaultSuperAdminRole' requireTenant />,
                children: [{ path: 'zero-x-processing', element: <SuperAdminCryptoDashboardPage /> }],
              },
              {
                path: 'accounts',
                element: <SuperAdminAccountsPage />,
              },
              {
                path: 'flags',
                element: <SuperAdminFlagsPage />,
              },
              {
                path: 'actions',
                element: <SuperAdminActionsPage />,
              },
              {
                path: 'database-queries',
                element: <SuperAdminDatabaseQueriesPage />,
              },
              {
                path: 'dashboard',
                element: (
                  <TabNavigation
                    basePath='super-admin/dashboard'
                    tabs={SUPER_ADMIN_DASHBOARD_TABS}
                    icon={<Circle fontSize='inherit' />}
                  />
                ),
                children: [
                  {
                    index: true,
                    element: <Navigate to='./bullboard' />,
                  },
                  {
                    path: 'bullboard',
                    element: <SuperAdminBullboardPage />,
                  },
                  {
                    path: 'ftb-backoffice',
                    element: (
                      <SuperAdminDashboardIframePage
                        title='FTB Backoffice'
                        links={[
                          {
                            label: 'FTB Backoffice',
                            url: runtimeEnv.superAdminFtbBackofficeUrl,
                          },
                        ]}
                      />
                    ),
                  },
                  {
                    path: 'rabbitmq',
                    element: (
                      <SuperAdminDashboardIframePage
                        title='RabbitMQ'
                        links={[{ label: 'RabbitMQ', url: runtimeEnv.superAdminRabbitMqUrl }]}
                      />
                    ),
                  },
                  {
                    path: 'zabbix',
                    element: (
                      <SuperAdminDashboardIframePage
                        title='Zabbix'
                        links={[{ label: 'Zabbix', url: runtimeEnv.superAdminZabbixUrl }]}
                      />
                    ),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

const router = createBrowserRouter(routes);

export default router;
